import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, inject } from '@angular/core';
import { CheckboxControlValueAccessor, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SaveDataService } from '@app/shared/services/save-data.service';
import { LabelCode } from '@app/shared/interfaces/label-code.interface';
import { ClickDirective } from 'angular-calendar/modules/common/click/click.directive';
import { SelectButtonOptionClickEvent } from 'primeng/selectbutton/public_api';
import { Checkbox, CheckboxChangeEvent } from 'primeng/checkbox';
import { CoreModule } from '@app/core/core.module';
import { AppService } from '@app/app.service';

@Component({
    selector: 'app-recruitment',
    standalone: true,
    imports: [CoreModule, CommonModule, SharedModule, TranslateModule],
    templateUrl: './recruitment.component.html',
    styleUrl: './recruitment.component.scss',
})
export class RecruitmentComponent {

    private appData = inject(AppService);

    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    recruitmentTitle = 'features.recruitment.recruitmentTitle';
    recruitmentSubtitle1 = 'features.recruitment.recruitmentSubtitle1';
    recruitmentSubtitle2 = 'features.recruitment.recruitmentSubtitle2';
    textrecruitment = 'features.recruitment.textrecruitment';

    checkrecruitment = 'features.recruitment.checkrecruitment';
    inforecruitment = 'features.recruitment.inforecruitment';

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;

    formGroup!: FormGroup;

    booleanCheck:boolean = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private saveDataService: SaveDataService,
        private changeStepService: ChangeStepService,
        private fb: FormBuilder,
    ) {
        this.changeStepService.changeStep(22);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });

        this.createForm();
        this.setValuesForm(this.appData.data.userData);

        this.formIsValid();
    }

    createForm() {
        this.formGroup = this.fb.group({
            recruit: new FormControl (false, [Validators.required, Validators.requiredTrue]),
        });
    }

    setValuesForm(value?: any) {
        if (value != undefined) {
            this.formGroup = this.fb.group({
                recruit: new FormControl (value.recruitment.recruit ? value.recruitment.recruit : this.booleanCheck, [Validators.required, Validators.requiredTrue]),
            });
        }
    }

    //-------------------------//
    //------EVENT METHODS------//
    //-------------------------//

    onChangeRecuitment(event: Event) {
        this.formIsValid();
    }

    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.createForm();
        this.saveDataService.saveDataLocal(this.formGroup.value, 'recruitment');
        this.router.navigate(['/main/step/bank-details'], { relativeTo: this.route });
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'recruitment');
        this.router.navigate(['/main/step/authentications/authentication'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}
